import { render, staticRenderFns } from "./page-header-menu-mobile.vue?vue&type=template&id=4cd85e46"
import script from "./page-header-menu-mobile.js?vue&type=script&lang=js&external"
export * from "./page-header-menu-mobile.js?vue&type=script&lang=js&external"
import style0 from "./page-header-menu-mobile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports